import QuickCashOrder from './views/main.c.js';
export default QuickCashOrder;
